import { Link } from "react-router-dom";
import type { Work } from "@/mocks/works";

export default function WorkCard({ work }: { work: Work }) {
  return (
    <Link
      to={`/work/${work.id}`}
      className="group block overflow-hidden rounded-xl bg-background-50 border border-background-200 transition-transform duration-300 hover:-translate-y-1"
      aria-label={`查看漫画 ${work.title} 详情`}
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={work.cover}
          alt={`${work.title} 漫画封面`}
          title={`${work.title} 新作首发`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute left-2 top-2 flex flex-col items-start gap-1.5">
          {work.isExclusive && (
            <span className="rounded-full bg-primary-500 px-2 py-0.5 text-[11px] font-bold text-background-50">
              独家首发
            </span>
          )}
          {work.isNew && (
            <span className="rounded-full bg-accent-500 px-2 py-0.5 text-[11px] font-bold text-background-50">
              新作上架
            </span>
          )}
        </div>
        <span
          className={`absolute right-2 top-2 rounded-full px-2 py-0.5 text-[11px] font-semibold ${
            work.status === "已完结"
              ? "bg-background-200/90 text-foreground-700"
              : "bg-background-950/70 text-background-50"
          }`}
        >
          {work.status}
        </span>
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/80 to-transparent p-3 pt-8">
          <div className="flex items-center justify-between text-[11px] text-background-50">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-secondary-400" />
              <b>{work.rating}</b>
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line" /> {work.views}
            </span>
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="truncate font-heading text-base font-bold text-foreground-900 md:text-lg">
          {work.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-600 md:text-sm">{work.author} · {work.category}</p>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {work.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
        <div className="mt-2 flex items-center justify-between text-[11px] text-foreground-500 md:text-xs">
          <span className="truncate">{work.latestChapter}</span>
          <span className="ml-2 whitespace-nowrap">{work.updateTime}</span>
        </div>
      </div>
    </Link>
  );
}